exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".required {\n  color: red;\n}\n.example-full-width {\n  width:100%;   \n}\n.profileimg {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  position: relative;\n  cursor: pointer;\n}\n.profileimg label {\n  color: #FFF;\n  font-size: 12px;\n  padding: 10px 15px;\n  background: #B1B1B1;\n}\n.profileimg input[type=\"file\"] {\n  top: 0;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  margin-bottom: 0;\n  position: absolute;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-master/register-client/register-client.component.css
// module id = ../../../../../src/app/mnt-master/register-client/register-client.component.css
// module chunks = main